(() => {
  const EVENT_NAME = /^annur:[a-z0-9_]+$/;
  const BLOCKED_KEY_PARTS = /(^|_)(address|company|customer|email|name|nif|notes|phone|sku)(_|$)/i;

  function sanitizeValue(value, depth = 0) {
    if (depth > 2 || value === null || value === undefined) return undefined;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (typeof value === 'string') {
      const normalized = value.trim();
      return normalized ? normalized.slice(0, 160) : undefined;
    }
    if (Array.isArray(value)) {
      return value
        .slice(0, 20)
        .map((item) => sanitizeValue(item, depth + 1))
        .filter((item) => item !== undefined);
    }
    if (typeof value !== 'object') return undefined;

    return Object.fromEntries(
      Object.entries(value)
        .filter(([key]) => !BLOCKED_KEY_PARTS.test(key))
        .map(([key, item]) => [key, sanitizeValue(item, depth + 1)])
        .filter(([, item]) => item !== undefined),
    );
  }

  function publish(eventName, eventData = {}) {
    if (!EVENT_NAME.test(eventName)) return false;

    const payload = sanitizeValue(eventData);
    try {
      const accepted = window.Shopify?.analytics?.publish?.(eventName, payload);
      if (window.ANNUR_TRACKING_DEBUG === true) {
        console.debug('[Annur tracking]', { eventName, payload, accepted });
      }
      return accepted === true;
    } catch (error) {
      if (window.ANNUR_TRACKING_DEBUG === true) {
        console.warn('[Annur tracking] Event not published', eventName, error);
      }
      return false;
    }
  }

  window.AnnurAnalytics = Object.freeze({ publish, sanitize: sanitizeValue });
})();
